import { useScrollReveal } from '@/hooks/useScrollReveal';

const cards = [
  {
    icon: 'fas fa-fish',
    title: 'SEGURANÇA ALIMENTAR',
    text: 'Solicitamos juntos aos órgãos governamentais a aquisição de cestas básicas para distribuir aos pescadores artesanais',
    image: '/images/sections/3e6f767ad4f8287475f568852d9ece9f.jpg',
    imgStyle: { objectPosition: 'center 15%' },
  },
  {
    icon: 'fas fa-balance-scale',
    title: 'DEFESA DE DIREITOS DOS PESCADORES ARTESANAIS',
    text: 'Nós pressionamos o governo para proteger os direitos dos pescadores artesanais e a vida marinha.',
    image: '/images/sections/295149c6043b5744524298b5d777d93c.jpg',
  },
  {
    icon: 'fas fa-heartbeat',
    title: 'AÇÕES DE SAÚDE E CIDADANIA',
    text: 'Criamos e compartilhamos relatórios, fichas técnicas, e vídeos sobre o estado dos nossos rios e levamos ações de saúde e cidadania para os ribeirinhos.',
    image: '/images/sections/25aacf4e94379e2e78364047c82bee39.jpg',
  },
];

export default function FightingForFishermen() {
  const [ref, vis] = useScrollReveal();

  return (
    <section data-testid="fighting-section" className="py-20 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`text-center mb-14 transition-all duration-800 ${vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block px-4 py-1.5 bg-[#1A8C7A]/10 text-[#1A8C7A] text-xs font-bold tracking-wider uppercase rounded-full mb-4">
            Nossos Pilares
          </span>
          <h2
            data-testid="fighting-title"
            className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1A1A2E] mb-4"
            style={{ letterSpacing: '-0.02em' }}
          >
            LUTANDO POR NOSSOS <span className="text-[#1A8C7A]">PESCADORES</span>
          </h2>
          <div className="w-20 h-1 bg-[#E8621A] mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card, i) => (
            <FightCard key={i} card={card} delay={i * 150} />
          ))}
        </div>
      </div>
    </section>
  );
}

function FightCard({ card, delay }) {
  const [ref, vis] = useScrollReveal(0.2);

  return (
    <div
      ref={ref}
      data-testid={`fight-card-${card.title.toLowerCase().replace(/\s+/g, '-').slice(0, 20)}`}
      className={`fight-card relative bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100
        transition-all duration-700 ${vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="h-48 overflow-hidden">
        <img
          src={card.image}
          alt={card.title}
          className={`w-full h-full object-cover hover:scale-110 transition-transform duration-500`}
          style={card.imgStyle || {}}
        />
      </div>
      <div className="p-6 sm:p-8">
        <div className="w-14 h-14 rounded-xl bg-[#1A8C7A]/10 flex items-center justify-center mb-5 -mt-12 relative z-10 border-4 border-white shadow-md">
          <i className={`${card.icon} text-[#1A8C7A] text-xl`}></i>
        </div>
        <h3 className="text-base sm:text-lg font-bold text-[#1A1A2E] mb-3 leading-tight">
          {card.title}
        </h3>
        <p className="text-sm text-[#4A5568] leading-relaxed">
          {card.text}
        </p>
      </div>
    </div>
  );
}
